/**
 * Auto-formats an input string as SSN: NNN-NN-NNNN or ***-**-NNNN
 */
export const formatSSN = (val?: string | null): string => {
  if (!val) return '';

  // Preserve masked echo if prefilled from backend (e.g. ***-**-1234)
  if (val.startsWith('***-**-')) {
    const digits = val.slice(7).replace(/\D/g, '').slice(0, 4);
    return `***-**-${digits}`;
  }

  // Strip all non-digits
  const cleaned = val.replace(/\D/g, '').slice(0, 9);
  if (cleaned.length === 0) return '';
  if (cleaned.length <= 3) return cleaned;
  if (cleaned.length <= 5) return `${cleaned.slice(0, 3)}-${cleaned.slice(3)}`;
  return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 5)}-${cleaned.slice(5)}`;
};

/**
 * Validation for the SSN field.
 */
export const SSN_RULE = {
  pattern: /^(?:\d{3}-\d{2}-\d{4}|\*{3}-\*{2}-\d{4})$/,
  message: 'An SSN is nine digits, written as 123-45-6789',
};
